/**
 * Sidebar Navigation Component
 *
 * Main navigation menu in sidebar.
 */

import { NavItem } from './nav-item';
import { useNavigationItems } from '../../hooks/use-navigation-items';

interface SidebarNavProps {
  isCollapsed: boolean;
}

export const SidebarNav = ({ isCollapsed }: SidebarNavProps) => {
  const { mainItems, isActive } = useNavigationItems();

  return (
    <nav className="flex-1 px-3 py-4 overflow-y-auto">
      <div className="space-y-1">
        {mainItems.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            isActive={isActive(item.path)}
            isCollapsed={isCollapsed}
          />
        ))}
      </div>
    </nav>
  );
};

export default SidebarNav;
